module.exports = __webpack_public_path__ + "static/media/pfp.85d06aea.png";